<template>
  <section class="download-app-modal">
    <h3 class="download-app-modal__title">Download via:</h3>
    <div class="download-app-modal__buttons">
      <img class="download-app-modal__badge"
           :src="androidBadge"
           alt="Get it on Google Play"
           role="button"
           tabindex="0"
           @click="selectPlayStore"
           @keydown.enter="selectPlayStore"
           @keydown.space.prevent="selectPlayStore">
      <img class="download-app-modal__badge"
           :src="appleBadge"
           alt="Download on the App Store"
           role="button"
           tabindex="0"
           @click="selectAppStore"
           @keydown.enter="selectAppStore"
           @keydown.space.prevent="selectAppStore">
    </div>
  </section>
</template>

<script>
  import {trackEvent} from '@/utils/logger';
  import GTAG_EVENT_ACTION from '@/reference/gtag-event-actions-lookup';
  import {GTAG_PARAMS_TYPE, GTAG_PARAMS_ORIGIN} from '@/reference/gtag-params-lookup';
  import CloseModalMixin from '@/mixins/close-modal-mixin';
  import AndroidBadge from '@/assets/images/android.svg';
  import AppleBadge from '@/assets/images/apple.svg';

  const APP_STORE_URL = 'https://apps.apple.com/app/apple-store/id1490833154?pt=95629810&ct=nsp_bb_preview&mt=8';
  const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.leapfroggr.nowserving&referrer=utm_source%3Dnsportal%26utm_campaign%3Dnsp_bb_preview';

  export default {
    name: 'download-app-modal',
    mixins: [CloseModalMixin],
    data() {
      return {
        androidBadge: AndroidBadge,
        appleBadge: AppleBadge,
      };
    },
    methods: {
      trackStoreClick(source) {
        const payload = {
          type: GTAG_PARAMS_TYPE.BabybookPreview,
          source,
        };
        this.$gtag.event(GTAG_EVENT_ACTION.Click, payload);
        trackEvent(GTAG_EVENT_ACTION.Click, payload);
      },
      selectPlayStore() {
        this.trackStoreClick(GTAG_PARAMS_ORIGIN.BabybookPreview_PlayStore);
        window.open(PLAY_STORE_URL, '_blank', 'noopener');
        this.closeModal();
      },
      selectAppStore() {
        this.trackStoreClick(GTAG_PARAMS_ORIGIN.BabybookPreview_AppStore);
        window.open(APP_STORE_URL, '_blank', 'noopener');
        this.closeModal();
      },
    },
  };
</script>

<style lang="scss">
  .download-app-modal {
    @extend %layout--flex-col-center-y;
    gap: space(m-base);
    padding: space(base) space(m-base);

    &__title {
      @extend %smd-font-family-bold;
      margin: 0;
      font-size: font(m);
      line-height: 1.2;
      color: $color-black;
      text-align: center;
      text-transform: none;
    }

    &__buttons {
      @extend %layout--flex-col;
      gap: space(m);
      width: 100%;
      max-width: 260px;
    }

    &__badge {
      display: block;
      width: 100%;
      height: auto;
      cursor: pointer;

      &:focus {
        outline: none;
      }

      &:focus-visible {
        outline: 2px solid #565af4;
        outline-offset: 4px;
      }
    }
  }
</style>